export default __webpack_public_path__ + "static/media/required-star.5c09785d.svg";